import React from "react";
// @ts-ignore
import { Button } from "@lululemon/ui-library";
import { SearchTexts } from "../../../utils/constants";

// Styles
import styles from "./NoSearchResultsTopQueries.module.scss";

interface NoSearchResultsTopQueriesProps {
  searchTerm: string;
  topQueries: QueryRecommendation["records"];
  isFrenchLocale: boolean;
  onClick: (searchQuery: string) => void;
}

const {
  SEARCH_TITLE_NO_MATCH,
  POPULAR_SEARCH_TERMS,
  NO_RESULTS_TRY_AGAIN,
  NO_RESULTS,
} = SearchTexts;

/**
 * @NoSearchResultsTopQueries for displaying Top Queries when no matches are found.
 * @param {NoSearchResultsTopQueriesProps} props - The props for the NoSearchResults component.
 * @returns {JSX.Element} JSX element representing the NoSearchResultsTopQueries UI.
 */

const NoSearchResultsTopQueries = (
  props: NoSearchResultsTopQueriesProps
): JSX.Element => {
  const { searchTerm = "", topQueries, isFrenchLocale, onClick } = props;

  const NO_RESULT_SUBTITLE = isFrenchLocale ? NO_RESULTS : NO_RESULTS_TRY_AGAIN;

  const subTitle =
    topQueries?.length > 0 ? POPULAR_SEARCH_TERMS : NO_RESULT_SUBTITLE;

  return (
    <div className={styles.noSearchResultsTextWrapper}>
      <p className={`${styles.noSearchResultsTitle} lll-text-small`}>
        <span
          className={styles.noTitleText}
        >{`${SEARCH_TITLE_NO_MATCH}\u00A0`}</span>
        <span className="OneLinkNoTx">{searchTerm}</span>
      </p>

      <br />
      <p
        data-testid="no-result-subtitle"
        className={`${styles.noSearchResultsSubtitle} lll-text-body-1`}
      >
        {subTitle}
      </p>
      <div className={styles.noSearchResultsTextRecommendations}>
        {!isFrenchLocale &&
          topQueries?.map((query) => (
            <Button
              key={query}
              data-testid="query-recommender"
              variant="transparent"
              className={`${styles.term} lll-link-primary`}
              onClick={() => onClick(query)}
            >
              <span className="lll-text-body-1">{query}</span>
            </Button>
          ))}
      </div>
    </div>
  );
};

NoSearchResultsTopQueries.displayName = "NoSearchResultsTopQueries";

export default NoSearchResultsTopQueries;
